import type { Theme, SxStyles } from 'geoview-core/ui/style/types';

/** Shared translucent background color for the swiper handle and divider. */
const SWIPE_CONTROL_BACKGROUND_COLOR = 'rgba(50, 50, 50, 0.75)';

/**
 * Gets custom sx classes for the swiper.
 *
 * @param theme - The MUI theme object
 * @param mapHeight - The map height
 * @returns The sx classes object
 */
export const getSxClasses = (theme: Theme, mapHeight: number): SxStyles => ({
  layerSwipe: {
    position: 'absolute',
    width: '100%',
    height: `calc(${mapHeight}px - 40px)`,
  },

  handle: {
    backgroundColor: SWIPE_CONTROL_BACKGROUND_COLOR,
    color: theme.palette.common.white,
    width: '24px',
    height: '24px',
  },

  bar: {
    position: 'absolute',
    backgroundColor: SWIPE_CONTROL_BACKGROUND_COLOR,
    zIndex: 151,
    boxSizing: 'content-box',
    margin: theme.spacing(0),
    padding: `${theme.spacing(0)} !important`,
    touchAction: 'none',
  },

  vertical: {
    width: '8px',
    height: '100%',
    cursor: 'col-resize',
    top: '0px!important',

    '& .handleContainer': {
      position: 'relative',
      width: '58px',
      height: '24px',
      zIndex: 1,
      top: '50%',
      left: '-25px',

      '& .handleR': {
        transform: 'rotate(90deg)',
        float: 'right',
      },

      '& .handleL': {
        transform: 'rotate(90deg)',
        float: 'left',
      },
    },
  },

  horizontal: {
    width: '100%',
    height: '8px',
    cursor: 'row-resize',
    left: '0px!important',

    '& .handleContainer': {
      position: 'relative',
      height: '58px',
      width: '24px',
      zIndex: 1,
      left: '50%',
      top: '-24px',

      '& .handleL': {
        verticalAlign: 'top',
        marginBottom: theme.spacing(1),
      },
    },
  },
});
